import "@babel/polyfill";
//import "babel-polyfill";
require("es6-promise").polyfill();

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "isomorphic-fetch";

import "@mdi/font/css/materialdesignicons.css";
import API from "@aws-amplify/api";
import PubSub from "@aws-amplify/pubsub";
import awsconfig from "./aws-exports";
import vuetify from "./plugins/vuetify";
import * as AmplifyModules from "aws-amplify";
import { Auth } from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";

import "@/styles/global.css";
import VModal from "vue-js-modal";
import { HTTP, HTTP_GAP, HTTP_LNLADMIN, HTTP_LND } from "./http-common.js";

Vue.use(VModal, { dialog: true });

Auth.configure(awsconfig);

Vue.use(AmplifyPlugin, AmplifyModules);

API.configure(awsconfig);
PubSub.configure(awsconfig);

// Vue.filter("formatDate", function(value) {
//   if (value) {
//     return moment(String(value)).format("MM/DD/YYYY hh:mm");
//   }
// });

// Vue.use(VDraggableTreeView);
Vue.filter("status", function(value) {
  try {
    switch (value) {
      case "A":
        return "Active";
      case "I":
        return "Inactive";
      case "F":
        return "Failed";
      case "P":
        return "Pending";
      default:
        return "Unknown";
    }
  } catch (e) {
    return value;
  }
});

Vue.filter("dateTime", function(value) {
  try {
    const dateFormat = require("dateformat");

    let newDate = dateFormat(value, "mm/dd/yyyy h:MM TT");
    return newDate;
  } catch (e) {
    return value;
  }
});

Vue.filter("mmddyyyy", function(value) {
  try {
    if (!value) return value;

    const dateFormat = require("dateformat");

    let newDate = dateFormat(value, "mm/dd/yyyy");
    return newDate;
  } catch (e) {
    return value;
  }
});

Vue.filter("hhmm", function(value) {
  try {
    const dateFormat = require("dateformat");

    let newDate = dateFormat(value, "h:MM TT");
    return newDate;
  } catch (e) {
    return value;
  }
});

Vue.filter("dateFromString", function(value) {
  try {
    const dateFormat = require("dateformat");

    let dateValue = new Date(value.replace("00:00:00", "23:59:59"));
    let retValue = dateFormat(dateValue, "mm/dd/yyyy");
    return retValue;
  } catch (e) {
    return value;
  }
});

Vue.filter("phone", function(value) {
  try {
    if (value.length == 10)
      return (
        "(" +
        value.substring(0, 3) +
        ") " +
        value.substring(3, 6) +
        "-" +
        value.substring(6)
      );
    else if (value.length == 7)
      return value.substring(0, 3) + "-" + value.substring(3);
    else return value;
  } catch (e) {
    return value;
  }
});

Vue.config.productionTip = false;

HTTP.interceptors.request.use(function(config) {
  return new Promise(resolve => {
    Auth.currentSession()
      .then(session => {
        config.headers.Authorization = session.accessToken.jwtToken;
        resolve(config);
      })
      .catch(() => {
        resolve(config);
      });
  });
});

HTTP_LND.interceptors.request.use(function(config) {
  return new Promise(resolve => {
    if (window.sessionStorage.getItem("jwt")) {
      config.headers.Authorization = window.sessionStorage.getItem("jwt");
    }
    resolve(config);
  });
});

HTTP_LND.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status == 401) {
      store.commit("setCurrentUser", null);
      window.sessionStorage.removeItem("currentUser");

      store.commit("setUserRoles", null);
      window.sessionStorage.removeItem("primaryAgentNum");

      // store.commit("setJWT", null);
      // window.sessionStorage.removeItem("jwt");

      store.commit("setJWT", "invalid_jwt");
      window.sessionStorage.setItem("jwt", "invalid_jwt");

      store.commit("setAccessCode", null);
      window.sessionStorage.removeItem("accessCode");

      store.commit("setTmkClientId", null);
      window.sessionStorage.removeItem("tmkClientId");

      router.push("/unauthenticated");
    } else return Promise.reject(error.message);
  }
);

HTTP_GAP.interceptors.request.use(function(config) {
  return new Promise(resolve => {
    if (window.sessionStorage.getItem("jwt")) {
      config.headers.Authorization = window.sessionStorage.getItem("jwt");
    }
    resolve(config);
  });
});

HTTP_GAP.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (!error.response) {
      return Promise.reject(error.message);
    }
    if (error.response.status == 401) {
      store.commit("setCurrentUser", null);
      window.sessionStorage.removeItem("currentUser");

      store.commit("setUserRoles", null);
      window.sessionStorage.removeItem("primaryAgentNum");

      // store.commit("setJWT", null);
      // window.sessionStorage.removeItem("jwt");

      store.commit("setJWT", "invalid_jwt");
      window.sessionStorage.setItem("jwt", "invalid_jwt");

      store.commit("setAccessCode", null);
      window.sessionStorage.removeItem("accessCode");

      store.commit("setTmkClientId", null);
      window.sessionStorage.removeItem("tmkClientId");

      router.push("/unauthenticated");
    } else return Promise.reject(error.message);
  }
);

HTTP_LNLADMIN.interceptors.request.use(function(config) {
  return new Promise(resolve => {
    Auth.currentSession()
      .then(session => {
        config.headers.Authorization = session.accessToken.jwtToken;
        resolve(config);
      })
      .catch(() => {
        resolve(config);
      });
  });
});

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
